import { render } from "./LeaveAdjustment.vue?vue&type=template&id=54a68f87&scoped=true"
import script from "./LeaveAdjustment.vue?vue&type=script&lang=js"
export * from "./LeaveAdjustment.vue?vue&type=script&lang=js"

import "./LeaveAdjustment.vue?vue&type=style&index=0&id=54a68f87&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a68f87"]])

export default __exports__